/* eslint-disable */

export const handleUserValidation = (formData) => {
    const errors = {};
  
    const requiredFields = ['userName', 'password', 'firstName', 'mobileNumber', 'userGroup'];
  
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = `${field} is required`;
      }
    });
  
    if (formData.emailID) {
      const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      if (!emailPattern.test(formData.emailID)) {
        errors.emailID = 'Email is not valid';
      }
    }
  
    // Return true if there are no errors
    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  };
  